// initial state
import * as base from './base.js'
const baseName = '/admin/labelType'



const labelList = baseName + '/list'
const labelAdd = baseName + '/add'
const labelEdit = baseName + '/edit'



const obj = base.setBaseUrl('labelType', baseName)
const obj1 = base.setBaseUrl('labelTypeList', labelList)
const obj2 = base.setBaseUrl('labelTypeAdd', labelAdd)
const obj3 = base.setBaseUrl('labelTypeEdit', labelEdit)


const a = Object.assign(obj, obj1, obj2, obj3,{ labelList, labelAdd,labelEdit})
export default a
